// extracted by mini-css-extract-plugin
module.exports = {"item":"_02712f2b3b--item--vdBTe"};